import React from 'react';
import { Box, Typography, IconButton, useTheme } from '@mui/material';
import { faFilter, faPlus } from '@fortawesome/sharp-regular-svg-icons';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { ActivityProps } from '@europrocurement/flexy-components/types/ActivityHistoryTypes';

type ActivityFilter = 'all' | 'notes' | 'important_notes' | 'actions';

export type ActivitiesHeaderProps = {
    activities: ActivityProps[];
    currentFilter: ActivityFilter;
    onCreateNote: () => void;
    onFilterClick: (event: React.MouseEvent<HTMLElement>) => void;
};

export const ActivitiesHeader: React.FunctionComponent<ActivitiesHeaderProps> = function ({
    activities,
    currentFilter,
    onCreateNote,
    onFilterClick,
}) {
    const theme = useTheme();

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '8px',
            }}
        >
            <Typography
                variant="l2dbodys"
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px',
                    fontSize: '12px',
                }}
            >
                {activities.length === 1 ? 'Activité' : `${activities.length} activités`}
            </Typography>
            <Box sx={{ display: 'flex', gap: '2px' }}>
                <IconButton
                    size="small"
                    onClick={onCreateNote}
                    sx={{
                        padding: '2px',
                        color: 'text.secondary',
                        '&:hover': { color: theme.palette.primary.main },
                    }}
                    title="Ajouter une note"
                >
                    <FaOptionIcon
                        icon={faPlus}
                        sx={{ fontSize: '10px' }}
                    />
                </IconButton>
                <IconButton
                    size="small"
                    onClick={onFilterClick}
                    sx={{
                        padding: '2px',
                        color:
                            currentFilter !== 'all' ? theme.palette.primary.main : 'text.secondary',
                        '&:hover': { color: theme.palette.primary.main },
                    }}
                    title="Filtres"
                >
                    <FaOptionIcon
                        icon={faFilter}
                        sx={{ fontSize: '10px' }}
                    />
                </IconButton>
            </Box>
        </Box>
    );
};
